//
//
//
//

/*跳转付款审批页面*/
import {selectPayRecordById} from "@/api/contract/payRecord";
export default {
    name: "approvePay",
  created(){
    //设置流程参数传递到详细页面
    var taskParam=this.$route.query;
    var data={id:taskParam.businessKey};
    selectPayRecordById(data).then( response => {

      if(response.contTypeCode=='purchase_contract'){
        this.$router.push({ path:'/payRecord/payPurchaseDetail',query:{id:response.id,taskParam}});
      }
      if(response.contTypeCode=='ctrip_businessTravel'){
        this.$router.push({ path:'/payRecord/payCtripDetail',query:{id:response.id,taskParam}});
      }
      if(response.contTypeCode=='humanDay_outsourcing'){
        this.$router.push({ path:'/payRecord/payHumanDayDetail',query:{id:response.id,taskParam}});
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/view/payRecord/approvePay.vue